import { useState, useCallback, useMemo } from 'react'
import { createUseStyles } from 'react-jss'
import ReactHtmlParser from 'react-html-parser'
import SingleAccordion from '@/components/SingleAccordion'
import style from './style'

const useStyles = createUseStyles(style)

const WhistleblowingAccordion = ({ data }) => {
  const classes = useStyles()

  const flatArray = useMemo(() => data.map((g) => g.accordions).flat(), [data])

  const [accordionStates, setAccordionStates] = useState(new Array(flatArray.length).fill(false))

  const handleActiveAccordion = useCallback((index) => (state) => {
    setAccordionStates(() => {
      const newState = new Array(flatArray.length).fill(false)
      newState[index] = state
      return newState
    })
  }, [setAccordionStates, flatArray])

  return (
    <div className={classes.root}>
      {data.map((accordionGoup, i) => {
        const k = i.toString()
        return (
          <div
            key={k}
            className={classes.accordionGroup}
          >
            <h3 className={classes.accordionTitle}>
              {accordionGoup.title}
            </h3>
            <div className={classes.accordionsWrapper}>
              {accordionGoup.accordions.map((accordion, j) => {
                const kk = j.toString()
                const accordionIndex = flatArray.findIndex((a) => a.post_title === accordion.post_title)
                return (
                  <SingleAccordion
                    key={kk}
                    title={accordion.post_title}
                    active={accordionStates[accordionIndex]}
                    setActive={handleActiveAccordion(accordionIndex)}
                  >
                    <div className={classes.accordionContent}>
                      {ReactHtmlParser(accordion.post_content)}
                    </div>
                  </SingleAccordion>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default WhistleblowingAccordion
